import { render, staticRenderFns } from "./RowComponent.vue?vue&type=template&id=28a12935&scoped=true&"
import script from "./RowComponent.vue?vue&type=script&lang=js&"
export * from "./RowComponent.vue?vue&type=script&lang=js&"
import style0 from "./RowComponent.vue?vue&type=style&index=0&id=28a12935&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a12935",
  null
  
)

export default component.exports